import mutations from './eprofileLezartProblemak.mutations'
import actions from './eprofileLezartProblemak.actions'
import getters from './eprofileLezartProblemak.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
